import React from 'react';
import { Helmet } from 'react-helmet-async';
import { generateBreadcrumbSchema } from '../utils/seo';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
  showHome?: boolean;
}

/**
 * BreadcrumbSchema component - provides SEO structured data without visual breadcrumbs
 * This component only outputs Schema.org JSON-LD markup for search engines
 * Use this for SEO benefits without cluttering the UI
 */
const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({ 
  items, 
  showHome = true 
}) => {
  // Add home to breadcrumbs if not already present and showHome is true
  const breadcrumbItems: BreadcrumbItem[] = showHome && items[0]?.path !== '/dashboard' 
    ? [{ name: 'Home', path: '/dashboard' }, ...items]
    : items;

  // Generate breadcrumb schema for SEO
  const breadcrumbSchema = generateBreadcrumbSchema(
    breadcrumbItems.map(item => ({
      name: item.name,
      url: `https://clipthis.io${item.path}`
    }))
  );

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;

